/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import {
  Divider,
  CircularProgress,
  Card,
  Typography,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import ReceiptIcon from "@material-ui/icons/Receipt";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import TrendingDownIcon from "@material-ui/icons/TrendingDown";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ListAltIcon from "@material-ui/icons/ListAlt";
import { HttpRequest } from "../../../utils/httpRequests";
import NavBar from "../../../components/NavBar/NavBar";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";

const useStyles = () => ({
  root: {
    padding: 10,
    margin: "70px 20px",
  },
  topMargin: {
    marginTop: 20,
  },
  filterCard: {
    padding: 20,
    marginBottom: 20,
  },
  summaryCard: {
    padding: 20,
    textAlign: "center",
    borderRadius: 8,
  },
  summaryIcon: {
    fontSize: 40,
    marginBottom: 8,
  },
  summaryAmount: {
    fontWeight: 700,
    fontSize: "1.5rem",
  },
  summaryLabel: {
    color: "#666",
    fontSize: "0.85rem",
  },
  tableCard: {
    marginTop: 20,
    padding: 10,
  },
  sectionTitle: {
    fontWeight: 700,
    marginBottom: 10,
    marginTop: 20,
  },
  searchButton: {
    textTransform: "capitalize",
    padding: "10px 24px",
    marginLeft: 10,
    height: 40,
  },
  chip: {
    margin: 2,
    fontSize: "0.75rem",
  },
  noData: {
    textAlign: "center",
    padding: 40,
    color: "#999",
  },
  orderIdCell: {
    fontWeight: 600,
    color: "#1976d2",
  },
});

const getTodayDate = () => {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const yyyy = today.getFullYear();
  return `${yyyy}-${mm}-${dd}`;
};

const formatDateForApi = (dateStr) => {
  if (!dateStr) return "";
  const [yyyy, mm, dd] = dateStr.split("-");
  return `${dd}-${mm}-${yyyy}`;
};

const formatCurrency = (amount) => {
  if (amount == null) return "0.00";
  return Number(amount).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

class C305SaleOrdersRevenueView extends React.Component {
  constructor(props) {
    super(props);
    const today = getTodayDate();
    this.state = {
      fromDate: today,
      toDate: today,
      fromDateError: "",
      toDateError: "",

      revenueData: null,
      isLoading: false,

      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",

      isLoginMenu: false,
      isReload: true,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value, [`${name}Error`]: "" });
  };

  validate = () => {
    const { fromDate, toDate } = this.state;
    let valid = true;
    if (!fromDate) {
      this.setState({ fromDateError: "From date is required" });
      valid = false;
    }
    if (!toDate) {
      this.setState({ toDateError: "To date is required" });
      valid = false;
    }
    if (fromDate && toDate && fromDate > toDate) {
      this.setState({ toDateError: "To date must be after From date" });
      valid = false;
    }
    return valid;
  };

  fetchData = async () => {
    if (!this.validate()) return;

    const { fromDate, toDate } = this.state;
    const apiFrom = formatDateForApi(fromDate);
    const apiTo = formatDateForApi(toDate);

    this.setState({ isLoading: true, revenueData: null });

    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C305SaleOrdersRevenueView?fromDate=${apiFrom}&toDate=${apiTo}`,
      null,
      "authorizeJson"
    );

    if (res.isSuccess) {
      const rawData = res.data;
      // API returns { CODE, DATA: [...] } — extract first element
      const revenueData =
        rawData?.DATA?.[0] ?? rawData?.[0] ?? rawData ?? null;
      this.setState({ revenueData, isLoading: false });
    } else {
      if (res.statusCode === 401) {
        this.setState({ isLoginMenu: true, isLoading: false });
      } else {
        this.setState({
          isLoading: false,
          isOpenSnackbar: true,
          snackbarMessage: "Failed to fetch data. Please try again.",
          snackbarSeverity: "error",
        });
      }
    }
  };

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  render() {
    const { classes } = this.props;
    const {
      fromDate, toDate, fromDateError, toDateError,
      isLoading, revenueData,
    } = this.state;

    const orders = revenueData?.orders || [];
    const carts = revenueData?.carts || [];
    const totalOrdersCount = orders.length || 0;
    const totalCartsCount = revenueData?.totalCartsCount || 0;
    const totalOrdersGrossAmount = revenueData?.totalOrdersGrossAmount || 0;
    const totalPriceListDiscount = revenueData?.totalPriceListDiscount || 0;
    const totalVoucherDiscount = revenueData?.totalVoucherDiscount || 0;
    const totalOrdersAmountAfterDiscounts = revenueData?.totalOrdersAmountAfterDiscounts || 0;

    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <CustomizedSnackbar
          isOpen={this.state.isOpenSnackbar}
          message={this.state.snackbarMessage}
          severity={this.state.snackbarSeverity}
          handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
          autoHideDuration={3000}
        />
        <NavBar isAuthorize />

        <div className={classes.root}>
          {/* Page Title */}
          <Typography variant="h5" color="primary" style={{ fontWeight: 700 }}>
            Sales Orders Revenue
          </Typography>

          <Divider style={{ marginTop: 10, marginBottom: 20 }} />

          {/* Filter Card */}
          <Card className={classes.filterCard}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={4} md={3}>
                <TextField
                  id="fromDate"
                  name="fromDate"
                  label="From Date"
                  type="date"
                  fullWidth
                  size="small"
                  variant="outlined"
                  value={fromDate}
                  onChange={this.handleChange}
                  error={!!fromDateError}
                  helperText={fromDateError}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={3}>
                <TextField
                  id="toDate"
                  name="toDate"
                  label="To Date"
                  type="date"
                  fullWidth
                  size="small"
                  variant="outlined"
                  value={toDate}
                  onChange={this.handleChange}
                  error={!!toDateError}
                  helperText={toDateError}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={3}>
                <Button
                  className={classes.searchButton}
                  variant="contained"
                  color="primary"
                  onClick={this.fetchData}
                  disabled={isLoading}
                  startIcon={<SearchIcon />}
                >
                  Search
                </Button>
              </Grid>
            </Grid>
          </Card>

          {/* Loading */}
          {isLoading && (
            <div style={{ display: "flex", justifyContent: "center", marginTop: 60 }}>
              <CircularProgress />
            </div>
          )}

          {/* Results */}
          {!isLoading && revenueData && (
            <Fragment>

              {/* Summary Cards */}
              <Grid container spacing={2} className={classes.topMargin}>
                <Grid item xs={12} sm={6} md={4}>
                  <Card className={classes.summaryCard} style={{ borderTop: "4px solid #1976d2" }}>
                    <ListAltIcon className={classes.summaryIcon} style={{ color: "#1976d2" }} />
                    <Typography className={classes.summaryAmount}>{totalOrdersCount}</Typography>
                    <Typography className={classes.summaryLabel}>Total Orders Count</Typography>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Card className={classes.summaryCard} style={{ borderTop: "4px solid #ff9800" }}>
                    <ShoppingCartIcon className={classes.summaryIcon} style={{ color: "#ff9800" }} />
                    <Typography className={classes.summaryAmount}>{totalCartsCount}</Typography>
                    <Typography className={classes.summaryLabel}>Total Carts Count</Typography>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Card className={classes.summaryCard} style={{ borderTop: "4px solid #5c6bc0" }}>
                    <ReceiptIcon className={classes.summaryIcon} style={{ color: "#5c6bc0" }} />
                    <Typography className={classes.summaryAmount}>{formatCurrency(totalOrdersGrossAmount)}</Typography>
                    <Typography className={classes.summaryLabel}>Gross Amount</Typography>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Card className={classes.summaryCard} style={{ borderTop: "4px solid #ef5350" }}>
                    <TrendingDownIcon className={classes.summaryIcon} style={{ color: "#ef5350" }} />
                    <Typography className={classes.summaryAmount}>{formatCurrency(totalPriceListDiscount)}</Typography>
                    <Typography className={classes.summaryLabel}>Price List Discount</Typography>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Card className={classes.summaryCard} style={{ borderTop: "4px solid #ab47bc" }}>
                    <LocalOfferIcon className={classes.summaryIcon} style={{ color: "#ab47bc" }} />
                    <Typography className={classes.summaryAmount}>{formatCurrency(totalVoucherDiscount)}</Typography>
                    <Typography className={classes.summaryLabel}>Voucher Discount</Typography>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Card className={classes.summaryCard} style={{ borderTop: "4px solid #4caf50" }}>
                    <CheckCircleOutlineIcon className={classes.summaryIcon} style={{ color: "#4caf50" }} />
                    <Typography className={classes.summaryAmount}>{formatCurrency(totalOrdersAmountAfterDiscounts)}</Typography>
                    <Typography className={classes.summaryLabel}>Amount After Discounts</Typography>
                  </Card>
                </Grid>
              </Grid>

              {/* Orders Table */}
              <Typography variant="h6" color="primary" className={classes.sectionTitle}>
                Orders
              </Typography>
              <Card className={classes.tableCard}>
                {orders.length > 0 ? (
                  <TableContainer component={Paper} elevation={0}>
                    <Table size="small">
                      <TableHead>
                        <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                          <TableCell><strong>Order ID</strong></TableCell>
                          <TableCell><strong>Created By</strong></TableCell>
                          <TableCell><strong>Created On</strong></TableCell>
                          <TableCell><strong>Gross Amount</strong></TableCell>
                          <TableCell><strong>Price List Disc.</strong></TableCell>
                          <TableCell><strong>Voucher Disc.</strong></TableCell>
                          <TableCell><strong>After Discounts</strong></TableCell>
                          <TableCell><strong>Category</strong></TableCell>
                          <TableCell><strong>Items</strong></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {orders.map((order) => (
                          <TableRow key={order.orderId} hover>
                            <TableCell className={classes.orderIdCell}>
                              #{order.orderId}
                            </TableCell>
                            <TableCell>{order.createdBy}</TableCell>
                            <TableCell>{order.createdOn}</TableCell>
                            <TableCell>
                              <strong>{formatCurrency(order.grossAmount)}</strong>
                            </TableCell>
                            <TableCell style={{ color: "#ef5350" }}>
                              -{formatCurrency(order.priceListDiscount)}
                            </TableCell>
                            <TableCell style={{ color: "#ab47bc" }}>
                              -{formatCurrency(order.voucherDiscount)}
                            </TableCell>
                            <TableCell style={{ color: "#4caf50" }}>
                              <strong>{formatCurrency(order.amountAfterDiscounts)}</strong>
                            </TableCell>
                            <TableCell>
                              {order.items && [...new Set(order.items.map(i => i.categoryUserLabel))].map((cat, idx) => (
                                <Chip
                                  key={idx}
                                  label={cat}
                                  size="small"
                                  className={classes.chip}
                                  variant="outlined"
                                  style={{ borderColor: "#9c27b0", color: "#9c27b0" }}
                                />
                              ))}
                            </TableCell>
                            <TableCell>
                              {order.items && order.items.map((item) => (
                                <Chip
                                  key={item.productId}
                                  label={item.userLabel}
                                  size="small"
                                  className={classes.chip}
                                  variant="outlined"
                                  color="primary"
                                />
                              ))}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Typography className={classes.noData}>No orders found.</Typography>
                )}
              </Card>

              {/* Carts Table */}
              <Typography variant="h6" color="primary" className={classes.sectionTitle}>
                Carts
              </Typography>
              <Card className={classes.tableCard}>
                {carts.length > 0 ? (
                  <TableContainer component={Paper} elevation={0}>
                    <Table size="small">
                      <TableHead>
                        <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                          <TableCell><strong>Cart ID</strong></TableCell>
                          <TableCell><strong>Created By</strong></TableCell>
                          <TableCell><strong>Status</strong></TableCell>
                          <TableCell><strong>Category</strong></TableCell>
                          <TableCell><strong>Product</strong></TableCell>
                          <TableCell><strong>Amount</strong></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {carts.map((cart) => (
                          <TableRow key={cart.cartId} hover>
                            <TableCell className={classes.orderIdCell}>
                              #{cart.cartId}
                            </TableCell>
                            <TableCell>{cart.createdBy}</TableCell>
                            <TableCell>{cart.statusLabel}</TableCell>
                            <TableCell>
                              {cart.categoryUserLabel || ""}
                            </TableCell>
                            <TableCell>
                              <Chip
                                label={cart.userLabel}
                                size="small"
                                className={classes.chip}
                                variant="outlined"
                                style={{ borderColor: "#ff9800", color: "#ff9800" }}
                              />
                            </TableCell>
                            <TableCell>
                              <strong>{formatCurrency(cart.amount)}</strong>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Typography className={classes.noData}>No carts found.</Typography>
                )}
              </Card>

            </Fragment>
          )}

          {/* No data yet */}
          {!isLoading && !revenueData && (
            <Card style={{ marginTop: 20, padding: 40, textAlign: "center" }}>
              <Typography style={{ color: "#999" }}>
                Select a date range and click Search to view revenue data.
              </Typography>
            </Card>
          )}

        </div>
      </Fragment>
    );
  }
}

C305SaleOrdersRevenueView.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(C305SaleOrdersRevenueView);